var PostcodeFormatter = (function () {
    function PostcodeFormatter() {
    }
    PostcodeFormatter.prototype.formatPostcode = function (postcode) {
        return postcode
            ? postcode
                .toUpperCase()
                .replace(/^([A-Z]{1,2}[0-9]{1,2}[A-Z]?) ?([0-9][ABDEFGHJLNPQRSTUWXYZ]{2})$/, '$1 $2')
            : postcode;
    };
    return PostcodeFormatter;
}());
export default PostcodeFormatter;
//# sourceMappingURL=postcodeFormatter.js.map